// extracted by mini-css-extract-plugin
module.exports = {"tourName":"Account_tourName__5964r","tourLanguage":"Account_tourLanguage__3asD5"};